export default __webpack_public_path__ + "static/media/takeshort.51ace1f8.png";